import SidebarLayout from "../../../../layouts/SidebarLayout";
import TemplateTable from "./_components/TemplateTable";

export default function AllTemplates() {
  return (
    <SidebarLayout title="Ticket Management">
      <TemplateTable />
    </SidebarLayout>
  );
}
